import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, Spin } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';

import { useUpdateSchoolProgramSectionMutation } from '@/api/endpoints/schools/schoolSubjectionParams/program';
import { DataSection, TextAreaField } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { SECTION_VALIDATION_SCHEMA } from '../../consts';
import type { ISectionItemData, TFormData } from '../../types';

import styles from './SectionModals.module.scss';

type TProps = {
  schoolId: number;
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  handleClearOperateItem: VoidFunction;
  itemToOperate: ISectionItemData;
};

export const EditProgramSectionModal = ({
  schoolId,
  isModalOpen,
  handleCancel,
  handleClearOperateItem,
  itemToOperate,
}: TProps) => {
  const [editProgramSection, { isLoading: isProgramSectionUpdating }] = useUpdateSchoolProgramSectionMutation();
  const sendApiRequest = useApiRequest();

  const methods = useForm<TFormData>({
    defaultValues: {
      name: itemToOperate ? itemToOperate.name : '',
      description: itemToOperate ? itemToOperate.description : '',
    },
    resolver: yupResolver(SECTION_VALIDATION_SCHEMA),
  });

  const { handleSubmit } = methods;

  const handleSaveProgramSection = handleSubmit(({ name, description }) => {
    sendApiRequest({
      successMessage: 'Раздел успешно изменён',
      apiRequestCallback: () =>
        editProgramSection({
          programSectionId: itemToOperate.id,
          schoolId,
          data: {
            name,
            description,
          },
        }),
      successCallback: () => {
        handleCancel();
        handleClearOperateItem();
      },
    });
  });

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={isProgramSectionUpdating}>
        <div className={styles.wrapper}>
          <FormProvider {...methods}>
            <p className={styles.title}>Изменение раздела программы</p>
            <div className={styles['content-wrapper']}>
              <DataSection
                titleText="Наименование раздела"
                isTitleRequired
              >
                <TextAreaField
                  fieldName="name"
                  placeholder="Наименование раздела"
                />
              </DataSection>
              <DataSection
                titleText="Описание раздела"
                isTitleRequired
              >
                <TextAreaField
                  fieldName="description"
                  placeholder="Описание раздела"
                />
              </DataSection>
            </div>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                onClick={handleCancel}
                className={styles.button}
                type="dashed"
              >
                Отмена
              </Button>
              <Button
                size="large"
                onClick={handleSaveProgramSection}
                type="primary"
                className={styles.button}
                disabled={isProgramSectionUpdating}
              >
                Сохранить
              </Button>
            </div>
          </FormProvider>
        </div>
      </Spin>
    </Modal>
  );
};
